import { useTranslation } from 'react-i18next'

import { SHIPMENT_STAGES } from '#/entities/shipment'
import type { ShipmentStage } from '#/entities/shipment'
import { cn } from '#/shared/lib/utils'
import type { ShipmentListCardRow } from '../model/types'

/** Orders flatten missing pickup/delivery to "-"; treat that as absent. */
function hasDate(value?: string): value is string {
  return !!value && value !== '-'
}

function RouteRow({
  dotClass,
  city,
  meta,
}: {
  dotClass: string
  city: string
  meta?: string
}) {
  return (
    <div className="flex items-center gap-2">
      <span className={cn('size-2 shrink-0 rounded-full', dotClass)} />
      <span className="min-w-0 truncate text-sm text-gray-900">{city}</span>
      {meta && (
        <>
          <span className="shrink-0 text-sm text-gray-500">·</span>
          <span className="shrink-0 text-sm text-gray-900">{meta}</span>
        </>
      )}
    </div>
  )
}

export function CardRoute({
  row,
  stage,
}: {
  row: ShipmentListCardRow
  stage: ShipmentStage
}) {
  const { t } = useTranslation()
  const isOrder = stage === SHIPMENT_STAGES.ORDER

  const originMeta = isOrder
    ? hasDate(row.pickupDate)
      ? t('shipmentCard.est', { date: row.pickupDate })
      : undefined
    : hasDate(row.shipDate)
      ? t('shipmentCard.availFrom', { date: row.shipDate })
      : undefined

  const destinationMeta =
    isOrder && hasDate(row.deliveryDate)
      ? t('shipmentCard.est', { date: row.deliveryDate })
      : undefined

  return (
    <div className="flex flex-col gap-0.75">
      <RouteRow dotClass="bg-green-500" city={row.origin} meta={originMeta} />
      <RouteRow
        dotClass="bg-orange-500"
        city={row.destination}
        meta={destinationMeta}
      />
    </div>
  )
}
